/* unplugin-vue-components disabled */import script from "./authProcess.vue?vue&type=script&lang=ts&setup=true"
export * from "./authProcess.vue?vue&type=script&lang=ts&setup=true"

import "./authProcess.vue?vue&type=style&index=0&id=47df29e1&lang=less&scoped=true"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47df29e1"]])

export default __exports__